'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { getConsent, onConsentChange } from '@/lib/analytics/consent';

const GADS_ID = 'AW-17894228694';

/**
 * Renders the Google Ads gtag.js loader only after the user has actively
 * accepted marketing cookies. Before that, no network request is made and no
 * pixel fires — required for DSGVO compliance.
 */
export function MarketingScripts() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional one-shot mount sync / external store subscription
    setAllowed(!!getConsent()?.marketing);
    return onConsentChange((state) => {
      setAllowed(!!state?.marketing);
    });
  }, []);

  if (!allowed) return null;

  return (
    <>
      <Script
        id="gtag-loader"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`}
      />
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GADS_ID}');
        `}
      </Script>
    </>
  );
}
